<template>
   <header class="p-3 pt-5 pb-3">
    <h5 class="text-center pb-4">Hej, hur kan vi hjälpa dig?</h5>

    <div class="d-flex align-items-center">
      <div v-if="selectedSubCat.id !== 0 && searchQuery.length < 2"
              :style="theme.darkText"
              @click="reset()"
              style="cursor: pointer; margin: 0 15px 0 0">
              <i class="fa-regular fa-arrow-left fa-lg ms-2"></i>
            </div>
      <input
      id="boxSearchInput"
        type="search"
        class="form-control form-control-lg shadow-sm border-0"
        placeholder="Sök på din fråga här"
        aria-label="Sök"
        v-model="searchQuery"/>
    </div>

  </header>

  <div id="boxTop" style="height: calc(100% - 170px); overflow-y: scroll">
    <div
      v-if="searchQuery.length > 2"
      class="accordion-flush bg-white searchResults w-100 shadow px-3"
      style="z-index: 9"
      id="boxSearchAccordion">
      <template v-if="searchResults">
        <div
          v-for="q in searchResults"
          class="accordion-item"
          style="cursor: pointer; :hover "
          :key="q.id">
          <div class="accordion-header">
            <div
              class="accordion-button collapsed px-0"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#search-collapse-' + q.id"
              aria-expanded="false"
              :aria-controls="'search-collapse-' + q.id"
              style="font-weight: 700; line-height: 1.5;"
              v-html="q.title.rendered"></div>
          </div>
          <div
            :id="'search-collapse-' + q.id"
            class="accordion-collapse collapse"
            :class="{ show: currentQ ? currentQ.id == q.id : '' }"
            :aria-labelledby="'heading' + q.id"
            data-bs-parent="#boxSearchAccordion">
            <div class="accordion-body p-2">
              <span v-html="q.content.rendered"></span>
              <a
                v-if="q.acf.call_to_action.length != 0"
                class="btn btn-primary mb-2"
                style="
                white-space:normal !important;"
                target="_blank"
                :href="q.acf.call_to_action_link"
                >{{ q.acf.call_to_action }}</a>

                <Transition name="slide-main">
                  <div :id="'vote-' + q.id" class="p-3 mt-3 bg-light"><strong class="d-block mb-1 text-center">Fick du svar på din fråga?</strong>
                    <div class="d-flex align-items-center justify-content-center">

                      <div>
                        <a @click="voteForm(q.id, 'like')" class="btn m-0" title="Ja, jag fick svar" aria-label="Ja, jag fick svar">
                          <i class="fa-regular fa-thumbs-up fa-lg"></i></a></div>


                      <div><a @click="voteForm(q.id, 'unlike')" class="btn m-0"  title="Nej, jag fick inget bra svar" aria-label="Nej, jag fick inget bra svar">
                        <i class="fa-regular fa-thumbs-down fa-flip-horizontal fa-lg"></i></a></div>

                    </div>
                  </div>
                  </Transition>
                  <Transition name="slide-sub">
                    <div :id="'voted-' + q.id" class="d-none"> <strong class='d-block p-3 bg-light text-center'>Tack för din
                        feedback!</strong></div></Transition>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-if="searchQuery.length > 2 && searchResults.length == 0">
      <div
        class="m-3 p-3 d-flex flex-row align-items-center bg-white rounded shadow"
        style="font-size: 16px !important">
        <i class="mr-3 fa-2x far fa-exclamation-triangle"></i>
        <div>Hittade tyvärr inget som matchade det du sökte på.</div>
      </div></template>

    <Transition name="slide-main">
      <div v-if="selectedMain.id == 0">
        <div class="text-muted ms-3 pt-3" style="font-size: 11px">
          Kategorier
        </div>
        <div class="d-flex flex-wrap text-center mx-2 align-items-stretch">
          <div
            v-for="(category, i) in mainCategories"
            :key="i"
            class="col-6 p-2"
            style="cursor: pointer">
            <div
              class="px-1 py-3 border-0 rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center"
              @click="selectMain(category)"
              :class="{ shadow: selectedSubCat.id == category.id }">
              <div
                class="iconBg rounded-circle d-flex justify-content-center align-items-center">
                <i :class="category.acf.icon"></i>
              </div>
              <span class="title" v-html="category.name"></span>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <Transition name="slide-sub">
      <div v-if="selectedMain.id != 0">
        <div
          class="w-100 my-3 px-3">
          

          <div
            id="categoryTitle"
            class="fw-bold text-center"
            v-html="selectedMain.name"></div>
          <div style="width: 60px"></div>
        </div>

   

        <div
          id="boxSubCatContainer"
          class="row text-center mx-2 pb-3 flex-nowrap overflow-auto"
          style="scroll-behavior: smooth; overflow: auto;">
          <template v-for="(category, i) in currentSubCats" :key="i">
            <div
              class="p-2"
              :class="currentSubCats.length > 2 ? 'col-7' : 'col-6'">
              <div
                class="px-1 py-3 border-0 rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center"
                @click="selectSubCat(category)"
                :class="{ shadow: selectedSubCat.id == category.id }">
                <div
                  class="iconBg rounded-circle d-flex justify-content-center align-items-center">
                  <i :class="category.acf.icon"></i>
                </div>
                <span class="title" v-html="category.name"></span>
              </div>
            </div>
          </template>
        </div>

        <div class="accordion-flush mx-3" id="boxQuestionAccordion">
          <!--fixa template för loopen-->

          <div
            class="accordion-item"
            v-for="(q, i) in currentQuestions"
            :key="i"
            :id="q.id"
            style="scroll-margin-top: 30px">
            <h2 class="accordion-header" :id="'heading' + q.id">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapse-' + q.id"
                aria-expanded="false"
                :aria-controls="'collapse-' + q.id"
                style="font-size: 16px !important; font-weight: 700; line-height: 1.5;"
                v-html="q.title.rendered"></button>
            </h2>
            <div :id="'collapse-' + q.id"
              class="accordion-collapse collapse"
              :class="{ show: currentQ ? currentQ.id == q.id : '' }"
              :aria-labelledby="'heading' + q.id"
              data-bs-parent="#questionAccordion">
              <div class="accordion-body px-2 py-0">
                <span style="font-size: 16px !important"
                  v-html="q.content.rendered"></span>

                <a v-if="q.acf.call_to_action.length != 0"
                  class="btn btn-primary"
                  target="_blank"
                  :href="q.acf.call_to_action_link"
                  >{{ q.acf.call_to_action }}</a>

                <Transition name="slide-main">
                    <div :id="'vote-' + q.id" class="p-3 mt-3 bg-light"><strong class="d-block mb-1 text-center">Fick du svar på din fråga?</strong>
                      <div class="d-flex align-items-center justify-content-center">
  
                        <div>
                          <a @click="voteForm(q.id, 'like')" class="btn m-0" title="Ja, jag fick svar" aria-label="Ja, jag fick svar">
                            <i class="fa-regular fa-thumbs-up fa-lg"></i>
                          </a></div>
  
  
                        <div><a @click="voteForm(q.id, 'unlike')" class="btn m-0" title="Nej, jag fick inget bra svar" aria-label="Nej, jag fick inget bra svar">                        
                          <i class="fa-regular fa-thumbs-down fa-flip-horizontal fa-lg"></i>
                        </a></div>
  
                      </div>
                    </div>
                    </Transition>
                    <Transition name="slide-sub">
                      <div :id="'voted-' + q.id" class="d-none"> <strong class='d-block p-3 bg-light text-center'>Tack för din
                          feedback!</strong></div></Transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  data() {
    let mainCategories = [];
    let subCategories = [];
    let searchResults = [];
    let currentQuestions = [];
    let questions = [];
    let selectedMain = { id: 0 };
    let selectedSubCat = { id: 0 };
    let currentSubCats = [];
    let currentQ;
    let searchQuery = ref("");
    let chatStatus = "online";
    let showFaq = false;
    let toggleIcon = "fa-solid fa-question-circle fs-2";

    return {
      mainCategories,
      subCategories,
      questions,
      selectedMain,
      selectedSubCat,
      currentSubCats,
      currentQuestions,
      currentQ,
      chatStatus,
      chat: false,
      searchQuery,
      searchResults,
      showFaq,
      toggleIcon,
      subScrollValue: 0,
      maxScrollLeft: 1,
    };
  },

  props: { theme: { type: Object }, site: { type: String }, setloading: { type: Function } },
  methods: {
    fetchData() {
      //let url1 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/categories?per_page=100&filter[meta_key]=site&filter[meta_value]="+this.site+"&filter[meta_compare]=LIKE";
      //let url2 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/faq?per_page=100&filter[meta_key]=site&filter[meta_value]="+ this.site +"&filter[meta_compare]=LIKE";

      let url1 =
        "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" +
        this.site +
        "&type=cat";
      let url2 =
        "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" +
        this.site +
        "&type=que";

      Promise.all([
        fetch(url1).then((res) => res.json()),
        fetch(url2).then((res) => res.json()),
      ]).then((json) => {
        json[0].map((cat) => {
          if (cat.parent == 0) {
            this.mainCategories.push(cat);
          } else {
            this.subCategories.push(cat);
          }
        });
        this.questions = json[1];
      this.setloading(false)
      });
    },

    selectMain(cat) {
      this.currentSubCats = [];
      if (this.subCategories.find(({ parent }) => parent == cat.id)) {
        this.selectSubCat(
          this.subCategories.find(({ parent }) => parent == cat.id)
        );
        //this.selectSubCat(this.subCategories[4])
      }
      this.subCategories.map((subCat) => {
        if (subCat.parent == cat.id) {
          this.currentSubCats.push(subCat);
        }
      });

      this.subScrollValue = 0;
      this.selectedMain = cat;
    },

    selectSubCat(cat) {
      this.currentQuestions = [];
      this.selectedSubCat = cat;

      this.questions.map((q) => {
        if (q.categories.find((id) => id == cat.id)) {
          this.currentQuestions.push(q);
        }
      });
    },

    setCurrentQ(q) {
      this.currentQ = q;
      this.currentQuestions = [];

      let subCat = this.subCategories.find(({ id }) => id == q.categories[0]);
      this.selectedMain = this.mainCategories.find(
        ({ id }) => id == subCat.parent
      );
      this.selectedSubCat = subCat;

      this.questions.map((q) => {
        if (q.categories[0] == subCat.id) {
          this.currentQuestions.push(q);
        }
      });

      if (this.searchResults.length > 1) {
        window.setTimeout(() => {
          document.getElementById(q.id).scrollIntoView({ behavior: "smooth" });
        }, 200);
        this.searchResults = [];
        this.searchQuery = "";
      }
    },

    reset() {
      this.selectedMain = { id: 0 };
      this.selectedSubCat = { id: 0 };
      this.currentQuestions = [];
      this.currentQ = "";
      this.searchQuery = "";
    },

    checkChatState(status) {
      if (status == "online") {
        this.chatOnline = true;
      } else {
        this.chatOnline = false;
      }
      this.iconControl();
    },

    iconControl() {
      if (this.showFaq == false && this.chatOnline == false) {
        this.toggleIcon = "fa-solid fa-question-circle fs-2";
      } else if (this.showFaq == false && this.chatOnline == true) {
        this.toggleIcon = " fa-solid fa-message-lines fs-3";
      } else {
        this.toggleIcon = "fa-light fa-xmark fs-3";
      }
    },

    subCatScroll(direction) {
      let subCatContainer = document.querySelector("#boxSubCatContainer");

      this.maxScrollLeft =
        subCatContainer.scrollWidth - subCatContainer.clientWidth - 1;

      direction == "right"
        ? (subCatContainer.scrollLeft += 150)
        : (subCatContainer.scrollLeft -= 150);
      window.setTimeout(() => {
        this.subScrollValue = subCatContainer.scrollLeft;
      }, 200);
      window.setTimeout(() => {
        console.log(subCatContainer.scrollLeft + "max: " + this.maxScrollLeft);
      }, 200);
    },

    voteForm(id, opinion) {
      var formData = new FormData();
      formData.append("id", id);
      formData.append("opinion", opinion);

      fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/vote/", {
        method: "POST",
        body: formData,
      });

      document.getElementById("vote-" + id).classList.add("d-none");
      document.getElementById("voted-" + id).classList.remove("d-none");
    },

    
    searchFilter(row) {
      //gör array av sökord
      let searchWordArray = this.searchQuery.split(" ");

      function filterWords(word) {
        let temp = false;

        if (row.title != null && row.title.rendered.toString().toLowerCase().includes(word.toLowerCase())) {
          temp = true;
        }

        Object.values(row).map((prop) => {
          if (
            prop != null &&
            prop.toString().toLowerCase().includes(word.toLowerCase())
          ) {
            temp = true;
          }
        });
        return temp;
      }

      //kolla om ett ord finns någonstans i object-value. Om det sker minst en gång ändras temp till true.
      return searchWordArray.every(filterWords);
    },
  },

  watch: {
    searchQuery() {

      this.searchResults = [];

      if (this.searchQuery.length > 0) {
        this.searchResults = this.questions.filter(this.searchFilter);
      
      }

        if(this.searchQuery.length > 2){
          
        document.getElementById("boxTop").scrollTop = 0;
        }



    },

    showFaq() {
      this.iconControl();
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
